import React, { useState } from "react";
import DomainSeoHelmet from "../agentic/DomainSeoHelmet";
import DomainHiddenSeoContent from "../agentic/DomainHiddenSeoContent";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "../agentic/domainUseCaseLayout";
import UseCaseIndexGrid from "../agentic/UseCaseIndexGrid";
import RpaProcessFlow from "./RpaProcessFlow";
import {
  MANUFACTURING_DOMAIN_INTRO,
  MANUFACTURING_GROUPS,
  MANUFACTURING_USE_CASES_SEO,
  MANUFACTURING_DOMAIN_FAQS,
  MANUFACTURING_ITEM_LIST_JSONLD,
  MANUFACTURING_BREADCRUMB_JSONLD,
  MANUFACTURING_WEBPAGE_JSONLD,
  MANUFACTURING_FAQ_JSONLD,
} from "../../data/rpa/manufacturingUseCases";

function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<RpaProcessFlow useCase={useCase} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = MANUFACTURING_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">
        {cases.map((uc) => (
          <UseCaseCard key={uc.id} useCase={uc} />
        ))}
      </div>
    </section>
  );
}

export default function ManufacturingRpaDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups =
    activeFilter === "all"
      ? MANUFACTURING_GROUPS
      : MANUFACTURING_GROUPS.filter((group) => group.id === activeFilter);

  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={MANUFACTURING_DOMAIN_INTRO}
        domainSlug="manufacturing"
        basePath="/rpa-use-cases"
        useCaseCount={MANUFACTURING_USE_CASES_SEO.length}
        groupCount={MANUFACTURING_GROUPS.length}
        itemListJsonLd={MANUFACTURING_ITEM_LIST_JSONLD}
        faqJsonLd={MANUFACTURING_FAQ_JSONLD}
        breadcrumbJsonLd={MANUFACTURING_BREADCRUMB_JSONLD}
        webPageJsonLd={MANUFACTURING_WEBPAGE_JSONLD}
        keywords="Manufacturing automation, document AI + RPA, workflow automation, robotic process automation India UAE KSA UK USA"
        sectionLabel=""
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{MANUFACTURING_DOMAIN_INTRO.title}</h1>
          {MANUFACTURING_DOMAIN_INTRO.content ? <p>{MANUFACTURING_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid
        useCases={MANUFACTURING_USE_CASES_SEO}
        groups={MANUFACTURING_GROUPS}
        heading="Manufacturing Use Cases"
        onFilterChange={setActiveFilter}
      />
      <div className="fin-wrap">
        {visibleGroups.map((group) => (
          <GroupSection key={group.id} group={group} />
        ))}
      </div>
      <DomainHiddenSeoContent
        domainTitle={MANUFACTURING_DOMAIN_INTRO.title}
        domainFaqs={MANUFACTURING_DOMAIN_FAQS}
        useCases={MANUFACTURING_USE_CASES_SEO}
      />
    </div>
  );
}

